<template>
  <div>
    <div class="banner" :style="bannerStyle" >
      <div class="banner-head" >{{banner.head}}</div>
      <div class="banner-box" >
        <div class="banner-wrapper">
          <hr class="banner-line">
          <div class="banner-en" >{{banner.headEn}}</div>
          <hr class="banner-line">
        </div>
      </div>
      <div class="banner-subhead">{{banner.subhead}}</div>
    </div>
    <div class="product">
      <div class="title_box">
        <header>线上产品</header>
      </div>
      <div class="content-line2">
        <div class="content_box box1">
          <div class="fl item-left">
            <img class="APP-view" src="../assets/Stuff.jpg"/>
          </div>
          <div class="fr item-right">
            <strong>{{introduction.head}}</strong>
            <article v-html="introduction.description"></article>
          </div>
        </div>
      </div>
      <div class="content-line2">
        <div class="title_box">
          <header>声纹验证</header>
        </div>
        <div class="product-img img-box" >
          <!--<img  src="../assets/Product.jpg"/>-->
          <div class="product-tel">400 128 8966</div>
          <div class="product-tel-desc">远程在家 轻松验证 智能语音 高效便捷</div>
        </div>
      </div>
      <div class="content-line2 ">
        <div class="title_box">
          <header>人脸识别</header>
        </div>
        <div class="product-img-face img-box" >
          <!--<img  src="../assets/Product.jpg"/>-->
          <div class="product-tel"></div>
          <div class="product-tel-desc">远程在家 轻松验证 人脸识别 高效便捷</div>
        </div>
      </div>
      <div class="content-line2">
        <div class="content_box box2">
          <div class="fl item-left">
            <strong style="display: block">扫描二维码下载</strong>
            <div class="QCR-content">
              <div class="QCR-type"><i class="icon iconfont icon-android"></i>Android</div>
              <img class="QCR-image" :src="common.getPictureUrl(Android)" >
            </div>
          </div>
          <div class="fr item-right">
            <strong>{{usage.head}}</strong>
            <article v-html="usage.description"></article>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "Product",
    methods: {
      loadData() {
        this.common.post('content/list',
          { 'type':'product',},(response)=>{
            response.data.content.forEach(
              e=>{
                if(e.headEn === 'introduction'){
                  this.introduction = e;
                }
                if(e.headEn === 'IOS'){
                  this.IOS = e;
                }
                if(e.headEn === 'Android'){
                  this.Android = e;
                }
                if(e.headEn === 'usage'){
                  this.usage = e;
                }
              }
            );
          }
        )
        this.common.post('content/recentOne', {
            'type':'banner',
            'description':'product',
          },(response)=>{
            this.banner = response.data.content;
            this.bannerStyle = {
              'background-image': 'url('+this.$host+this.banner.image+')'
            };
          }
        )
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.loadData();
      })
    },
    data() {
      return {
        introduction:{},
        IOS:{},
        Android:{},
        usage: {},
        common:this.$common,
        bannerStyle:{},
        banner:{},
      }
    }
  }
</script>
<style src="../../static/css/iconfont.css"></style>
<style scoped>
  header{
    width: 1200px;
    font-size: 24px;
    line-height: 85px;
    margin: 0 auto;
  }
  .product-tel{
    position: relative;
    top: 80%;
    font-weight: bold;
    font-size: 24px;
    color: #448ACA;
  }
  .product-tel-desc{
    position: relative;
    top: 83%;
    font-weight: bold;
    font-size: 22px;
    color: #448ACA;
  }
  .img-box{
    text-align: center;
  }
  .product-img-face{
    margin: 0 auto;
    width: 1200px;
    height: 544px;
    background-image: url("../assets/product-face.jpg");
  }
  .product-img{
    margin: 0 auto;
    width: 1200px;
    height: 544px;
    background-size: contain;
    background-image: url("../assets/product-phone.jpg");
  }
  .product-img img{
    float: left;
    width: 1200px;
  }
  .QCR-content{
    margin-top: 80px;
  }
  .QCR-type{
    box-sizing: border-box;
    padding-left: 10px;
    margin: 79px 25px;
    width: 180px;
    float: left;
    font-size: 30px;
    border: #2e2e2e solid 1px;
    border-radius: 7px;
  }
  .QCR-image{
    width: 200px;
  }
  .box2 article{
    box-sizing: border-box;
    padding-top: 50px;
  }
  .box2 .item-left{
    box-sizing: border-box;
    padding-top: 50px;
  }
  .box2 .item-right{
    box-sizing: border-box;
    padding-top: 50px;
  }
  .box1 .item-right{
    box-sizing: border-box;
    padding-top: 50px;
  }

  .APP-view{
    width: 291px;
    height: 566px;
    /*background-size: contain;*/
    /*background: url("../assets/Stuff.jpg") no-repeat;*/
  }

  strong{
    font-size: 24px;
    color: rgba(68,138,202,1);
  }
  article{
    font-size: 14px;
    color: rgba(89,87,87,1);
  }
  .content_box {
    width: 1200px;
    margin:  20px auto 0;
    position: relative;
    overflow: hidden;
  }

  .item-left{
    box-sizing: border-box;
    padding-left: 50px;
    width: 600px;
    height: 500px;
    border-right: solid 1px #AAAAAA;
    font-size:14px;
    color: rgba(89, 87, 87, 1);;
  }
  .item-right{
    box-sizing: border-box;
    padding-left: 50px;
    width: 600px;
    height: 300px;
  }
  article{
    margin-top: 36px;
  }

  .content-line2:nth-child(odd){
    background:rgba(68,138,202,.3);
  }
  .center .name{
    text-align: center;
  }
  .icon-android{
    margin-right: 10px;
  }
  .fl {
    float: left;
  }
  .fr {
    float: right;
  }
  .iconfont{
    font-size: inherit;
  }

</style>



// WEBPACK FOOTER //
// src/components/Product.vue